import React, { useState, useEffect } from 'react';
import scheme from '../../static/js/scheme';
import {imgCrop} from '../../static/js/imgcrop';
import vm from '../../static/js/unit';
import Base from '../../base';
import './index.scss';

const Locker = ({tab, brand, setShow, show, params}) => {
  const [series, setSeries] = useState([]);
  const [hide, setHide] = useState(false);
  useEffect(() => {
    setSeries({});
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'getSeriesListByBrand',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        isev: tab === 'isEv' ? 1 : 0,
        brandid: brand.id,
      },
      success(res) {
        setSeries(res.result);
      }
    });
  }, [brand.id, tab]);

  const handleClick = () => {
    setHide(true);
    setTimeout(() => {
      setShow(false);
      setHide(false);
      document.body.style.overflow = 'auto';
    }, 300);
  }
  const handleLinkClick = (name) => {
    Base.tongji('carclick', {
      position: tab === 'isEv' ? 'ev' : 'all',
      name: name,
    });
  }

  return (
    <div className={`athm-locker ${hide ? 'anim-hide' : ''} ${!show ? 'fn-hide' : ''}`}>
      <div className="athm-locker__mask" onClick={handleClick}></div>
      <div className="athm-locker__content">
        {
          <p className="athm-locker__caption">
            <img alt={brand.name} src={brand.logo} />
            <span>{brand.name}</span>
          </p>
        }
        {
          series.length > 0 && series.map((fct, index) => {
            return <React.Fragment key={index}>
              <div className="athm-series__caption">
                {fct.fctname}
              </div>
              <ul>
                {
                  fct.list.length > 0 && fct.list.map(ser => {
                    return <li className="athm-series__item" key={ser.seriesid}>
                      <a onClick={() => handleLinkClick(ser.seriesname)} href={scheme.insidebrowser(`${process.env.REACT_APP_LINK}home/${brand.id}-${ser.seriesid}?source=series`)}>
                        <img src={imgCrop(ser.serieslogo, '160x0__')} alt={ser.seriesname} />
                        <div>
                          <strong>{ser.seriesname}</strong>
                          {
                            ser.tip && <span>{ser.tip}</span>
                          }
                          <p>{ser.levelname}</p>
                        </div>
                      </a>
                    </li>
                  })
                }
              </ul>
            </React.Fragment>
          })
        }
      </div>
    </div>
  )
}

export default Locker;